import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function VersandGuidePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.quest';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <nav className="fixed top-0 left-0 w-full z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-pie-chart-line text-background-50 text-base"></i>
            </div>
            <span className="font-heading text-foreground-900 text-lg font-semibold whitespace-nowrap">OOPBUY Spreadsheet</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-foreground-600 text-sm font-medium hover:text-foreground-900 transition-colors whitespace-nowrap">Startseite</Link>
            <Link to="/artikel/oopbuy-spreadsheet-einkaufsguide" className="text-foreground-600 text-sm font-medium hover:text-foreground-900 transition-colors whitespace-nowrap">Einkaufsguide</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap">Buy it now</a>
          </div>
        </div>
      </nav>

      <article className="pt-24 pb-16">
        <div className="max-w-[800px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-8 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-500 transition-colors"><i className="ri-home-4-line"></i></Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <Link to="/" className="hover:text-primary-500 transition-colors">Startseite</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-600">OOPBUY Spreadsheet Versand Guide</span>
          </nav>

          <header className="mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-5">
              <i className="ri-ship-line text-xs"></i>
              <span>Versand & Logistik</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-900 font-bold leading-tight">
              OOPBUY Spreadsheet Versand Guide: Lieferzeiten, Kosten & Zoll
            </h1>
            <p className="mt-4 text-foreground-500 text-base md:text-lg leading-relaxed">
              Alle Versandinformationen aus dem OOPBUY Spreadsheet für Deutschland, Österreich und die Schweiz. Lieferzeiten, Versandkosten, Zollbestimmungen und die besten Shipping-Lines im Überblick.
            </p>
            <div className="flex items-center gap-4 mt-6 text-foreground-400 text-sm">
              <span className="flex items-center gap-1.5"><i className="ri-calendar-line"></i>Aktualisiert: Juli 2026</span>
              <span className="flex items-center gap-1.5"><i className="ri-time-line"></i>9 Min. Lesezeit</span>
            </div>
          </header>

          <div className="relative rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20wrapped%20brown%20cardboard%20shipping%20boxes%20tied%20with%20natural%20twine%20on%20a%20light%20wooden%20table%2C%20a%20shipping%20label%20visible%20with%20a%20globe%20icon%2C%20a%20pair%20of%20white%20sneakers%20peeking%20out%20from%20one%20open%20box%2C%20soft%20natural%20daylight%20from%20a%20side%20window%2C%20warm%20cream%20and%20beige%20color%20palette%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20composition%2C%20organized%20and%20calm%20atmosphere%2C%20international%20shipping%20theme&width=1200&height=600&seq=versand-guide-hero-02&orientation=landscape"
              alt="OOPBUY Spreadsheet Versand Guide"
              className="w-full aspect-video object-cover"
            />
          </div>

          <div className="text-foreground-700 leading-relaxed space-y-10">
            <section>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-5">
                Versand mit dem OOPBUY Spreadsheet: Das Wichtigste zuerst
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                Das <strong>OOPBUY Spreadsheet</strong> ist nicht nur eine Produktdatenbank – es enthält auch umfassende Versandinformationen, die speziell für die <strong>DACH-Region</strong> optimiert sind. Von der Auswahl der richtigen Shipping-Line über Zollbestimmungen bis hin zu typischen Lieferzeiten: Hier finden Sie alles, was Sie für einen reibungslosen Versand nach Deutschland, Österreich oder in die Schweiz wissen müssen.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-5">
                Versandoptionen im Vergleich
              </h2>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="border-b border-background-200">
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold">Shipping-Line</th>
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold">Dauer</th>
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold">Kosten (ca.)</th>
                      <th className="text-left py-3 px-4 text-foreground-900 font-semibold">Zoll</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ['DHL Tarifless Line', '8–14 Werktage', '€25–45', 'Zollfrei (Triangle)'],
                      ['EU Tarifless Line', '10–16 Werktage', '€20–40', 'Zollfrei (Triangle)'],
                      ['DHL Europe Line', '7–12 Werktage', '€30–55', 'Zollfrei (IOSS)'],
                      ['EUB', '12–25 Werktage', '€8–20', 'Zollpflichtig'],
                      ['EMS', '10–20 Werktage', '€15–35', 'Zollpflichtig'],
                      ['China Post SAL', '20–40 Werktage', '€5–15', 'Zollpflichtig'],
                    ].map(([line, dauer, kosten, zoll]) => (
                      <tr key={line} className="border-b border-background-100 hover:bg-background-50 transition-colors">
                        <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">{line}</td>
                        <td className="py-3 px-4 text-foreground-600">{dauer}</td>
                        <td className="py-3 px-4 text-foreground-600">{kosten}</td>
                        <td className="py-3 px-4">{zoll.includes('frei') ? <span className="text-primary-600 font-medium text-xs">{zoll}</span> : <span className="text-accent-600 font-medium text-xs">{zoll}</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-4 text-foreground-500 text-xs">
                Hinweis: Die Angaben basieren auf Erfahrungswerten aus dem OOPBUY Spreadsheet und können je nach Saison und Paketgröße variieren.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-5">
                Zollbestimmungen für Deutschland
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                Ein wichtiger Punkt, den das <strong>OOPBUY Spreadsheet</strong> ausführlich behandelt: die Zollbestimmungen. Für Sendungen aus China nach Deutschland gilt:
              </p>
              <div className="mt-5 space-y-4">
                {[
                  { title: 'Warenwert unter €150', desc: 'Einfuhrumsatzsteuer (19 % bzw. 7 %) fällt an, aber kein Zoll. Die Abwicklung erfolgt meist über IOSS direkt beim Kauf.', icon: 'ri-money-euro-circle-line' },
                  { title: 'Warenwert über €150', desc: 'Zusätzlich zur Einfuhrumsatzsteuer wird Zoll fällig. Der Zollsatz variiert je nach Produktkategorie zwischen 0 % und 17 %.', icon: 'ri-bank-line' },
                  { title: 'Triangle Shipping', desc: 'Viele im OOPBUY Spreadsheet empfohlene Lines nutzen Triangle Shipping (über ein EU-Land). Das Paket wird innerhalb der EU weiterverschickt und umgeht so den deutschen Zoll.', icon: 'ri-triangle-line' },
                  { title: 'Gefälschte Markenware', desc: 'Achtung: Der Import von gefälschten Markenprodukten ist illegal und kann zur Beschlagnahmung und Strafanzeige führen. Das OOPBUY Spreadsheet kennzeichnet solche Risiken deutlich.', icon: 'ri-alert-line' },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4 p-5 rounded-2xl bg-background-100 border border-background-200/70">
                    <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-secondary-600 text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="text-foreground-900 font-semibold text-sm mb-1">{item.title}</h3>
                      <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-5">
                Versand-Tipps aus dem OOPBUY Spreadsheet
              </h2>
              <ul className="space-y-3">
                {[
                  'Nutzen Sie Triangle Shipping wann immer möglich – es ist sicherer und vermeidet Zollprobleme',
                  'Deklarieren Sie den Warenwert realistisch. Extrem niedrige Deklarationen erregen Verdacht beim Zoll',
                  'Teilen Sie große Bestellungen in mehrere kleinere Pakete auf, um unter der €150-Grenze zu bleiben',
                  'Fügen Sie Ihrer Bestellung immer eine Vakuumverpackung hinzu, um Volumengewicht zu sparen',
                  'Bestellen Sie Schuhe ohne Schuhkarton für geringeres Paketgewicht und Volumen',
                  'Kalkulieren Sie Versandkosten von Anfang an in Ihr Budget ein – sie können 30–50 % des Produktpreises ausmachen',
                ].map((tip, i) => (
                  <li key={i} className="flex items-start gap-3 p-4 rounded-xl bg-background-100">
                    <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 text-background-50 text-xs font-bold">{i + 1}</span>
                    <span className="text-foreground-600 text-sm leading-relaxed pt-0.5">{tip}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-5">
                Versand nach Österreich und in die Schweiz
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                Das <strong>OOPBUY Spreadsheet</strong> enthält auch spezifische Informationen für Österreich und die Schweiz. Für Österreich gelten ähnliche EU-Zollregeln wie für Deutschland, was den Versand deutlich vereinfacht. Für die Schweiz als Nicht-EU-Land gelten abweichende Bestimmungen – das Spreadsheet listet die besten Lines speziell für Schweizer Kunden.
              </p>
            </section>

            <section className="p-6 md:p-8 rounded-2xl bg-secondary-50 border border-secondary-200/50">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 font-bold mb-3">
                Fazit: Mit dem OOPBUY Spreadsheet sicher versenden
              </h2>
              <p className="text-foreground-600 leading-relaxed">
                Der Versand aus China muss keine Blackbox sein. Mit den detaillierten Versandinformationen aus dem <strong>OOPBUY Spreadsheet</strong> wissen Sie genau, welche Line die richtige für Ihr Paket ist, mit welchen Kosten Sie rechnen müssen und wie Sie Zollprobleme vermeiden. Nehmen Sie sich die Zeit, die Versandhinweise im Spreadsheet zu lesen – es spart Ihnen Geld, Nerven und unangenehme Überraschungen.
              </p>
            </section>
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-background-100 border border-background-200/70">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <div>
                <h3 className="text-foreground-900 font-semibold text-lg">Bereit für den Versand?</h3>
                <p className="text-foreground-500 text-sm mt-1">Nutzen Sie das OOPBUY Spreadsheet auf kaspreadsheet.com</p>
              </div>
              <div className="flex items-center gap-3">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap">OOPBUY Spreadsheet</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-6 py-2.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap">Buy it now</a>
              </div>
            </div>
          </div>

          <nav className="mt-10 pt-8 border-t border-background-200/70 flex flex-wrap items-center justify-between gap-4">
            <Link to="/" className="inline-flex items-center gap-2 text-foreground-600 hover:text-primary-500 transition-colors text-sm font-medium">
              <i className="ri-arrow-left-line"></i>Zurück zur Startseite
            </Link>
            <Link to="/artikel/oopbuy-spreadsheet-guide" className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 transition-colors text-sm font-medium">
              Hauptguide lesen<i className="ri-arrow-right-line"></i>
            </Link>
          </nav>
        </div>
      </article>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: 'OOPBUY Spreadsheet Versand Guide: Lieferzeiten, Kosten &amp; Zoll',
        description: 'Alle Versandinformationen aus dem OOPBUY Spreadsheet f&uuml;r Deutschland, &Ouml;sterreich und die Schweiz. Lieferzeiten, Versandkosten, Zollbestimmungen und die besten Shipping-Lines im &Uuml;berblick.',
        author: { '@type': 'Organization', name: 'OOPBUY Spreadsheet Guide' },
        publisher: { '@type': 'Organization', name: 'OOPBUY Spreadsheet Guide', logo: { '@type': 'ImageObject', url: siteUrl + '/favicon.ico' } },
        datePublished: '2026-07-01',
        dateModified: '2026-07-15',
        mainEntityOfPage: { '@type': 'WebPage', '@id': siteUrl + '/artikel/oopbuy-spreadsheet-versand-guide' },
        inLanguage: 'de',
      }) }} />

      <footer className="relative bg-foreground-900 mx-4 md:mx-6 mb-4 md:mb-6 rounded-3xl overflow-hidden">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-pie-chart-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-background-50 text-base font-semibold">OOPBUY Spreadsheet</span>
            </Link>
            <p className="text-foreground-500 text-xs">Unabhängige Informationsressource – nicht offiziell mit OOPBUY verbunden.</p>
          </div>
        </div>
      </footer>
    </main>
  );
}